export default __webpack_public_path__ + "static/media/ghosting.1f476be3.jpg";